import React from "react";
import TeamMember from "../../components/TeamMember/TeamMember";
import "./Team.css";

function Team() {
  return (
    <div className="container">
      <section className="team-section text-center">
        <h1 className="h1-responsive my-5 anchor-adjust" style={{ paddingTop: "50px", paddingBottom: "50px" }} id="team">
          Meet our Team
        </h1>

        <div className="row justify-content-md-center"  >

          <TeamMember
            Name={"Rodrigo Costa"}
            Title={"CTO - Innovation Lead"}
            Image="/assets/images/team/team1.jpg"
            Github={"http://github.com/costargc"}
            LinkedIn={"https://www.linkedin.com/in/costargc/en"}
          // Email={"costa@upself.io"}
          />
          <TeamMember
            Name={"Joana Faria"}
            Title={"Psychologist - LATAM Specialist"}
            Image="/assets/images/team/team5.png"
            Github={"https://melhorterapia.com.br/"}
            LinkedIn={"https://www.linkedin.com/in/joana-garcia-faria-756646112/"}
          // Email={"emily@upself.io"}
          />
          {/* <TeamMember
            Name={"Emily Baumgartner"}
            Title={"Web Developer"}
            Image="/assets/images/team/team4.jpg"
            Github={"https://github.com/emilybaum"}
            LinkedIn={"https://www.linkedin.com/in/emilybaum/"}
            // Email={"emily@upself.io"}
          /> */}
          {/* <TeamMember
            Name={"Esther Lee"}
            Title={"Web Developer"}
            Image="/assets/images/team/team3.jpg"
            Github={"https://github.com/esdalee"}
            LinkedIn={"https://www.linkedin.com/in/estherlee321/"}
            // Email={"esther@upself.io"}
          /> */}
          {/* <TeamMember
            Name={"Matt Gilliland"}
            Title={"Software Engineer"}
            Image="/assets/images/team/team2.jpg"
            Github={"https://github.com/mgilliland23"}
            LinkedIn={"https://www.linkedin.com/in/matthew-gilliland-77695595/"}
            // Email={"matt@upself.io"}
          /> */}
        </div>
      </section>
    </div>
  );
}

export default Team;
